import { SearchFacetData } from 'modules/search/types/SearchFacetData';

export const actionDateFacet = {
  id: 'actionDateFacet',
  name: 'actionDate',
  names: ['endsGT', 'startsLT'],
  title: getText('Date'),
  type: 'date',
  // Do not apply to date filters
  options: [],
  optionTitles: {},
} as const satisfies SearchFacetData;

export type ActionDateFacetValue = {
  endsGT: number | undefined;
  startsLT: number | undefined;
};
